import { useEffect, useState } from 'react';
import { getQuickAccessCodes } from '../API';

const QuickAccess = (props) => {
  const [helpOpen, setHelpOpen] = useState(false);
  const [shortcuts, setShortcuts] = useState([]);
  const [helpLoading, setHelpLoading] = useState(false);
  const [helpError, setHelpError] = useState('');

  const closeHelp = () => {
    setHelpOpen(false);
  };

  const openHelp = async () => {
    setHelpOpen(true);
    setHelpError('');
    setHelpLoading(true);

    try {
      const rows = await getQuickAccessCodes();
      setShortcuts(Array.isArray(rows) ? rows : []);
    } catch (err) {
      setShortcuts([]);
      setHelpError(err.message || 'Impossible de charger les raccourcis.');
    } finally {
      setHelpLoading(false);
    }
  };

  useEffect(() => {
    if (!helpOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeHelp();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [helpOpen]);

  return (
    <section className="chart-card transaction-form-card">
      <div className="transaction-section-heading">
        <h2 className="transaction-section-title">Accès rapide</h2>
        <button
          type="button"
          className="transaction-help-btn"
          aria-label="Afficher les raccourcis d'accès rapide"
          title="Raccourcis"
          onClick={openHelp}
        >
          ?
        </button>
      </div>
      <p className="transaction-section-hint">Entrez un raccourci configuré pour enregistrer rapidement une activité.</p>

      <form onSubmit={(event) => props.formQuickCompleteSubmitted(event)}>
        <div className={`transaction-input-row${props.goodShortcut != null ? '' : ' transaction-input-row-no-status'}`}>
          {props.goodShortcut != null && (
            <span
              className={`transaction-status-icon${props.goodShortcut === 1 ? ' transaction-status-icon-valid' : ' transaction-status-icon-invalid'}`}
              aria-hidden="true"
            >
              <i className={`${props.goodShortcut === 1 ? 'far fa-check-circle' : 'fas fa-times-circle'}`}></i>
            </span>
          )}
          <input
            autoComplete="off"
            placeholder="Raccourci"
            type="text"
            className="form-control"
            id="inputShortcut"
            onChange={(e) => props.handleShortcutChange(e)}
          />
          <input
            placeholder="Quantité"
            type="number"
            className="form-control transaction-qte-input"
            id="inputShortcutQte"
            value={props.qteQuick}
            onChange={props.handleQteQuick}
          />
        </div>

        {props.goodShortcut === 1 && (
          <input
            className="form-control transaction-desc-preview"
            type="text"
            value={props.shortcutDesc}
            readOnly
            aria-label="Description du code"
          />
        )}

        <div className="transaction-field">
          <label htmlFor="inputShortcutNotes">Notes</label>
          <textarea
            placeholder="Notes optionnelles"
            className="form-control"
            rows="4"
            id="inputShortcutNotes"
          />
        </div>

        {props.saveSuccess && (
          <div className="transaction-success-banner" role="alert">
            La transaction a été enregistrée.
          </div>
        )}

        <div className="transaction-submit-row">
          <button type="submit" className="btn btn-primary">
            Valider
          </button>
        </div>
      </form>

      {helpOpen && (
        <div className="shortcut-help-overlay" onClick={closeHelp}>
          <div
            className="shortcut-help-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="shortcut-help-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="shortcut-help-header">
              <h3 id="shortcut-help-title">Raccourcis d'accès rapide</h3>
              <button
                type="button"
                className="shortcut-help-close"
                aria-label="Fermer"
                onClick={closeHelp}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {helpLoading && <p className="shortcut-help-status">Chargement...</p>}
            {helpError && <p className="shortcut-help-error">{helpError}</p>}
            {!helpLoading && !helpError && shortcuts.length === 0 && (
              <p className="shortcut-help-status">Aucun raccourci configuré.</p>
            )}
            {!helpLoading && !helpError && shortcuts.length > 0 && (
              <div className="historique-table-wrap shortcut-help-table-wrap">
                <table className="table historique-table">
                  <thead>
                    <tr>
                      <th scope="col">Accès rapide</th>
                      <th scope="col">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shortcuts.map((row) => (
                      <tr key={`${row.quickaccess}-${row.description}`}>
                        <td>{row.quickaccess}</td>
                        <td>{row.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default QuickAccess;
